// src/stockx/base/HowItWorksIcon.tsx
import { Icon } from "@chakra-ui/icons";
import { jsx, jsxs } from "react/jsx-runtime";
var HowItWorksIcon = ({ colorized, ...props }) => /* @__PURE__ */ jsxs(Icon, { viewBox: "0 0 50 50", ...props, children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M28.9 35.5H20V34.4C20 34.4 19.9 30.8 18.1 29C16.2 27.2 15.1 24.6 15.1 21.9C15.1 16.4 19.5 12 25 12C30.5 12 34.9 16.4 34.9 21.9C34.9 24.6 33.8 27.2 31.8 29.1C30.1 30.9 29.9 34.4 29.9 34.5V35.6L28.9 35.5ZM22.1 33.3H27.8C28 31.8 28.5 29.2 30.2 27.5C31.7 26 32.6 24.1 32.6 22C32.6 17.8 29.2 14.4 25 14.4C20.8 14.4 17.4 17.8 17.4 22C17.4 24.1 18.3 26.1 19.8 27.5C21.4 29.2 22 31.8 22.1 33.3Z",
      fill: colorized ? "#221F1F" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M20 33.3V37.5H22V39.9H28V37.5H30V33.3H20Z",
      fill: colorized ? "#221F1F" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M13.5 19.5H7V21.7H13.5V19.5Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M11.3539 10.0886L10.1555 11.9335L15.6064 15.4741L16.8048 13.6292L11.3539 10.0886Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M14.5774 26.1016L9.12524 29.6402L10.3229 31.4856L15.7751 27.947L14.5774 26.1016Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M43 19.5H36.5V21.7H43V19.5Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M38.5905 10.1231L33.1383 13.6617L34.336 15.507L39.7882 11.9684L38.5905 10.1231Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      d: "M35.3636 26.1274L34.1655 27.9725L39.6171 31.5124L40.8152 29.6673L35.3636 26.1274Z",
      fill: colorized ? "#D4D1C7" : "currentColor"
    }
  )
] });
var HowItWorksIcon_default = HowItWorksIcon;

export {
  HowItWorksIcon_default
};
